<app-dialog [config]="config" (actionButtonClicked)="onFormSubmit($event)">
    <ng-container dialog-title>
        Assign Account
    </ng-container>

    <ng-container
        dialog-process-in-progress

        *ngIf="supervisedRightsForm && supervisedRightsForm.controls[0]"

        [formGroup]="supervisedRightsForm.form"
    >
        <div class="container-fluid">
            <ng-container [formArrayName]="supervisedRightsForm.supervisedRightsFormArraySelector">
                <ng-container [formGroupName]="0">
                    <div [ngClass]="{'mb-3': supervisedRightsForm.controls[0].nonSupervisedUsers.errors.length > 0}">
                        <app-select
                            [formControlName]="supervisedRightsForm.controls[0].nonSupervisedUsers.name"
                            [control]="supervisedRightsForm.controls[0].nonSupervisedUsers"
                        ></app-select>
                    </div>

                    <ng-container [formArrayName]="supervisedRightsForm.supervisedRightsArraySelector">
                        <div
                            *ngFor="let control of supervisedRightsForm.controls[0].rights; let i = index"

                            [ngClass]="{'mb-3': control.errors.length > 0}"
                        >
                            <app-checkbox
                                [formControlName]="i"
                                [control]="control"
                            >
                                <ng-container text>{{control.placeholder}}</ng-container>
                            </app-checkbox>
                        </div>
                        <div *ngIf='supervisedRightsForm.rightsErrors[0].length > 0' class="form-text text-danger mt-3">
                            <span *ngFor="let error of supervisedRightsForm.rightsErrors[0]">{{error}}</span>
                        </div>
                    </ng-container>
                </ng-container>
            </ng-container>
        </div>
    </ng-container>
</app-dialog>
